import Cookies from "js-cookie";
import React from "react";
import { Link } from "react-router-dom";
import { Layout, Menu } from 'antd';
import { useHistory } from "react-router";
import logo from "./logo-dzikra.jpg" ;  
import "../css/nav.css"


const { Header} = Layout;



const Nav = () => {


    let history = useHistory()

    const handleLogout = () => {
        Cookies.remove('user')
        Cookies.remove('token')
        history.push('/login')
    }

    
return (
    <>
   
    <Header className="header" style={{ position: 'fixed', zIndex: 1, width: '100%' }} >
      <div />
      <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>
        <Menu.Item key="0"><img src={logo} alt="logo" style={{width:"80px", height:"50px"}}/></Menu.Item>
        <Menu.Item key="1"><Link to="/">Movies</Link></Menu.Item>
        <Menu.Item key="2"><Link to="/games">Games</Link></Menu.Item>
        {Cookies.get('user') === undefined ? <> 
        <Menu.Item key="3" ><Link to="/login">Login</Link></Menu.Item>
        <Menu.Item key="4" > <Link to="/register">Register</Link></Menu.Item>
          </> : null}
          {Cookies.get('user') !== undefined ? <>
        <Menu.Item key="5" onClick={handleLogout}>Logout</Menu.Item>
      </> : null }
      </Menu>
    </Header>
    </>

)

}

export default Nav